<script setup lang="ts">
import { FontAwesomeIcon } from '@sunlabde/m2m-library';
import { computed } from 'vue';
import { useBreakpoints } from '@vueuse/core';
import CardQuote from './CardQuote.vue';
import TheAside from '@/components/TheAside.vue';
import { useUspItems } from '@/composables/useUspItems';
import { globalBreakpoints } from '@/utilities/Breakpoints';
import { asideQuotes } from '@/models/Quote';
import { useLocalization } from '@/models/Localization';

const { uspItems } = useUspItems();
const { greaterOrEqual } = useBreakpoints(globalBreakpoints);
const isGreaterOrEqualWidescreen = computed(() => greaterOrEqual('widescreen').value);

const { localize } = useLocalization();
</script>

<template>
	<TheAside :is-body-visible="isGreaterOrEqualWidescreen">
		<template #body>
			<transition
				name="fade-up"
				mode="out-in"
				appear
			>
				<div class="h-full flex flex-col gap-10">
					<ul class="text-xl font-semibold flex-col gap-6 justify-center hidden desktop:flex">
						<li
							v-for="uspItem in uspItems"
							:key="uspItem.icon"
							class="flex items-center justify-start gap-7 text-[20px]"
						>
							<div class="flex justify-center">
								<FontAwesomeIcon
									:icon="uspItem.icon"
									class="text-green-300 h-8 w-[45px]"
								/>
							</div>
							<p>{{ uspItem.text }}</p>
						</li>
					</ul>
					<div class="hidden gap-6 desktop:grid">
						<CardQuote
							v-for="(quoteItem, index) in asideQuotes"
							:key="localize(quoteItem.quote)"
							:quote="quoteItem"
							:class="{
								'mr-16': index % 2 !== 0,
								'ml-16': index % 2 === 0
							}"
						/>
					</div>
				</div>
			</transition>
		</template>
	</TheAside>
</template>
